import { configureStore } from "@reduxjs/toolkit"
// REDUCERS
import appStateReducer from "@redux/features/appState/appStateSlice"
import currentCompanyReducer from "@redux/features/currentCompany/currentCompanySlice"
import diseaseZonesReducer from "@redux/features/diseaseZones/diseaseZonesSlice"
import facilitiesReducer from "@redux/features/facilities/facilitiesSlice"
import filteredListOfFishFarmsReducer from "@redux/features/filteredListOfFishFarms/filteredListOfFishFarmsSlice"
import fishFarmOwnersReducer from "@redux/features/fishFarmOwners/fishFarmOwnersSlice"
import listOfVesselsReducer from "@redux/features/listOfVessels/listOfVesselsSlice"
import mapFiltersReducer from "@redux/features/mapFilters/mapFiltersSlice"
import consumptionMapFiltersReducer from "@redux/features/mapFilters/consumptionMapFiltersSlice"
import mapFiltersFacilitiesReducer from "@redux/features/mapFiltersFacilities/mapFiltersFacilitiesSlice"
import consumptionMapFiltersFacilitiesReducer from "@redux/features/mapFiltersFacilities/consumptionMapFiltersFacilitiesSlice"
import mapFiltersOilReducer from "@redux/features/mapFiltersOil/mapFiltersOilSlice"
import consumptionMapFiltersOilReducer from "@redux/features/mapFiltersOil/consumptionMapFiltersOilSlice"
import mapFiltersPanelStateReducer from "@redux/features/mapFiltersPanelState/mapFiltersPanelStateSlice"
import mapParamsReducer from "@redux/features/mapParams/mapParamsSlice"
import mapSidePanelControlReducer from "@redux/features/mapSidePanelControl/mapSidePanelControlSlice"
import offlineVesselsReducer from "@redux/features/offlineVessels/offlineVesselsSlice"
import routeTracerReducer from "@redux/features/routeTracerData/routeTracerDataSlice"
import selectedBunkerReportReducer from "@redux/features/selectedBunkerReport/selectedBunkerReportSlice"
import selectedFreightLetterReducer from "@redux/features/selectedFreightLetter/selectedFreightLetterSlice"
import selectedMrvSubEventReducer from "@redux/features/selectedMrvSubEvent/selectedMrvSubEventSlice"
import selectedVesselReducer from "@redux/features/selectedVessel/selectedVesselSlice"
import stateAliasesReducer from "@redux/features/stateAliases/stateAliasesSlice"
import timelineEventMarkerReducer from "@redux/features/timelineEventMarker/timelineEventMarkerSlice"
import underConfigurationVesselsReducer from "@redux/features/underConfigurationVessels/underConfigurationVesselsSlice"
import uniSeaVesselsReducer from "@redux/features/uniSeaVessels/uniSeaVesselsSlice"
import userDataReducer from "@redux/features/userData/userDataSlice"

export const store = configureStore({
	reducer: {
		appState: appStateReducer,
		facilities: facilitiesReducer,
		mapFiltersFacilities: mapFiltersFacilitiesReducer,
		consumptionMapFiltersFacilities: consumptionMapFiltersFacilitiesReducer,
		consumptionMapFilters: consumptionMapFiltersReducer,
		offlineVessels: offlineVesselsReducer,
		uniSeaVessels: uniSeaVesselsReducer,
		underConfigurationVessels: underConfigurationVesselsReducer,
		userData: userDataReducer,
		stateAliases: stateAliasesReducer,
		mapFiltersOil: mapFiltersOilReducer,
		mapFiltersPanelState: mapFiltersPanelStateReducer,
		routeTracerData: routeTracerReducer,
		selectedBunkerReport: selectedBunkerReportReducer,
		selectedMrvSubEvent: selectedMrvSubEventReducer,
		selectedVessel: selectedVesselReducer,
		currentCompany: currentCompanyReducer,
		mapFilters: mapFiltersReducer,
		consumptionMapFiltersOil: consumptionMapFiltersOilReducer,
		mapParams: mapParamsReducer,
		mapSidePanelControl: mapSidePanelControlReducer,
		listOfVessels: listOfVesselsReducer,
		timelineEventMarker: timelineEventMarkerReducer,
		selectedFreightLetter: selectedFreightLetterReducer,
		filteredListOfFishFarms: filteredListOfFishFarmsReducer,
		fishFarmOwners: fishFarmOwnersReducer,
		diseaseZones: diseaseZonesReducer,
	},
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: { warnAfter: 100 },
		}),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export const getAppState = (state: RootState) => state.appState
